module.exports = __webpack_public_path__ + "static/media/close-icon.394a39e7.svg";